var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'text-button',
    `text-button--${_vm.color}`,
    { 'text-button--active': _vm.active },
    { 'text-button--disabled': _vm.disabled },
    { 'text-button--always-underline': _vm.alwaysUnderline }
  ],attrs:{"active":_vm.active,"disabled":_vm.disabled,"type":"button","name":_vm.name},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }